import { APP_INITIALIZER, Injector, NgModule } from '@angular/core';
import { apply as applyCustomFieldsControllerPatch } from './patches/custom-fields.controller.patch'
import { OpSharedModule } from "core-app/shared/shared.module";
import { AttachmentAutocompleterComponent } from './components/op-attachment-autocompleter.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { registerCustomElement } from 'core-app/shared/helpers/angular/custom-elements.helper';
import { DisplayFieldService } from 'core-app/shared/components/fields/display/display-field.service';
import {
  ResourceDisplayField,
} from 'core-app/shared/components/fields/display/field-types/resource-display-field.module';
import {
  ResourcesDisplayField,
} from 'core-app/shared/components/fields/display/field-types/resources-display-field.module';
import { EditFieldService } from 'core-app/shared/components/fields/edit/edit-field.service';
import {
  MultiSelectEditFieldComponent,
} from 'core-app/shared/components/fields/edit/field-types/multi-select-edit-field.component';
import { AttachmentAutocompleterTemplateComponent } from './components/attachment-autocompleter-template.component';
import { AttachmentDisplayField } from './components/attachment-display-field.module';
import { AttachmentsDisplayField } from './components/attachments-display-field.module';
import {
  SelectEditFieldComponent,
} from 'core-app/shared/components/fields/edit/field-types/select-edit-field/select-edit-field.component';

applyCustomFieldsControllerPatch();

function initializeDisplayFields(displayFieldService:DisplayFieldService) {
  return () => {
    displayFieldService.addFieldType(ResourceDisplayField, 'resource', ['WorkPackage'])
    displayFieldService.addFieldType(ResourcesDisplayField, 'resources', ['[]WorkPackage'])
    displayFieldService.addFieldType(AttachmentDisplayField, 'attachment', ['Attachment'])
    displayFieldService.addFieldType(AttachmentsDisplayField, 'attachments', ['[]Attachment'])
  }
}

function initializeEditFields(editFieldService:EditFieldService) {
  return () => {
    editFieldService.addFieldType(MultiSelectEditFieldComponent, 'multi-select', ['[]WorkPackage'])
    editFieldService.addFieldType(SelectEditFieldComponent, 'select', ['Attachment'])
    editFieldService.addFieldType(MultiSelectEditFieldComponent, 'multi-select', ['[]Attachment'])
  }
}

@NgModule({
  imports: [
    NgSelectModule,
    OpSharedModule,
  ],
  declarations: [
    AttachmentAutocompleterComponent,
    AttachmentAutocompleterTemplateComponent,
  ],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: initializeEditFields,
      deps: [EditFieldService],
      multi: true,
    },
    {
      provide: APP_INITIALIZER,
      useFactory: initializeDisplayFields,
      deps: [DisplayFieldService],
      multi: true,
    },
  ],
})
export class PluginModule {
  constructor(injector:Injector) {
    registerCustomElement('opce-attachment-autocompleter', AttachmentAutocompleterComponent, { injector });
  }
}
